import { Box } from '@mui/material'
import { useLoadSellers } from 'modules/customers/hooks/useLoadSellers'
import { useState } from 'react'
import { SelectC } from 'components'
import { useDebounce } from 'utils'

export const SelectResponsible = () => {
  const [searchSeller, setSearcSeller] = useState<string>('')
  const searchSellerDebounced = useDebounce(searchSeller, 250)

  const { data: sellers, isLoading: loadingSellers } = useLoadSellers({
    page: 1,
    limit: 100,
    search: searchSellerDebounced,
    filters: {}
  })
  const handleChangeSeller = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearcSeller(value)
  }

  return (
    <SelectC
      name="responsibles"
      options={sellers?.data}
      loading={loadingSellers}
      label="Responsáveis"
      onInputChange={(e, value, reason) => handleChangeSeller(value, reason)}
      getOptionLabel={(option: any) => option?.name}
      isMultiple={true}
      disableCloseOnSelect
      renderOption={(props: any, option: any) => (
        <Box component="li" {...props}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{option.name}</div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                fontSize: 12
              }}
            >
              <div>{option?.registration}</div>
              <div style={{ marginLeft: 4, marginRight: 4 }}>|</div>
              <div>{option?.address || ''}</div>
            </div>
          </div>
        </Box>
      )}
    />
  )
}
